import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import dashboardAnalytics from '~/analytics/dashboard/dashboardAnalytics'
import { Link } from '~/components'
import { useHomeLink } from '~/hooks/useHomeLink'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '28px' }]

export const MobileLogo = (): React.ReactElement => {
  const { t } = useTranslation('imageAlt')
  const logoRoute = useHomeLink()

  const handleLogoClick = (): void => {
    dashboardAnalytics.handleHeaderTopMenuClick('logo')
  }

  return (
    <Link className="mobile" to={logoRoute}>
      <ResponsiveImage
        alt={t('icons.homShortLogo3D')}
        height={27}
        imageClassName="w-7 mr-2"
        loading="eager"
        mediaQuery={mediaQuery}
        onClick={handleLogoClick}
        srcKey="icons/hom-logo-mobile.svg"
        width={28}
      />
    </Link>
  )
}
